import React from 'react';
import CgRadixButton from 'modules/Common/ui/CgRadixButton';

/**
 * Mirrors CgPageHeaderBlock's anatomy — eyebrow, H1, meta line, right-slot actions —
 * so the console reads like the rest of the product, without importing the original.
 *
 * CgPageHeaderBlock is not reused because it pulls `useTranslation` and
 * `translateSectionKicker`, whose kickers are keyed to CUSTOMER sections, into an
 * English-only console (D13). Copying ~30 lines of layout beats inheriting a
 * component built for a different information architecture.
 */
export default function AdminPageHeader({ eyebrow, title, meta, primaryAction, rightSlot }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div className="min-w-0">
        {eyebrow ? (
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-400 mb-1">
            {eyebrow}
          </p>
        ) : null}
        <h1 className="text-2xl font-semibold text-slate-900 truncate">{title}</h1>
        {meta ? <p className="text-sm text-slate-500 mt-1">{meta}</p> : null}
      </div>
      <div className="flex items-center gap-2">
        {rightSlot}
        {primaryAction ? (
          <CgRadixButton
            variant="primary"
            icon={primaryAction.icon}
            label={primaryAction.label}
            loading={primaryAction.loading}
            onClick={primaryAction.onClick}
            data-testid="admin-primary-action"
          />
        ) : null}
      </div>
    </div>
  );
}
